module.exports = __webpack_public_path__ + "static/media/landing2.58425379.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing2.png
// module id = 695
// module chunks = 0